import { Controller } from '@hotwired/stimulus';
import Chart from "chart.js/auto";

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    url: String,
    data: Array,
    colors: Array,
    attribute: String
  }

  connect() {
    this.fetchData();
  }

  disconnect() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }

  reinit() {
    this.disconnect();
    this.connect();
  }

  renderChart(data) {
    this.chartInstance = new Chart(this.canvasTarget, {
      type: 'doughnut',
      data: {
        datasets: [{
          data: Object.values(data),
          backgroundColor: this.colorsValue || null
        }]
      },
      options: {
        animation: true,
        events: [],
        elements: {
          arc: {
            borderWidth: 0
          }
        },
        plugins: {
          legend: {
            display: false
          },
          emptyDoughnut: {
            color: '#D0D5DD',
            width: 31,
            radiusDecrease: 16
          }
        }
      },
      plugins: [this.emptyDoughnutPlugin()]
    });
  }

  fetchData() {
    if (this.hasUrlValue) {
      fetch(this.urlValue)
        .then((response) => response.json())
        .then((data) => {
          this.renderChart(this._tally(data.records, this.attributeValue))
        });
    } else {
      this.renderChart(this.dataValue);
    }
  }

  _tally(array, attribute) {
    return array.reduce((acc, element) => {
      let value = element[attribute];
      acc[value] = (acc[value] || 0) + 1;

      return acc;
    }, {})
  }
  emptyDoughnutPlugin() {
      return {
      id: 'emptyDoughnut',
      afterDraw(chart, args, options) {
        const {datasets} = chart.data;
        const {color, width, radiusDecrease} = options;
        let hasData = false;

        for (let i = 0; i < datasets.length; i += 1) {
          const dataset = datasets[i];
          hasData |= dataset.data.length > 0;
        }

        if (!hasData) {
          const {chartArea: {left, top, right, bottom}, ctx} = chart;
          const centerX = (left + right) / 2;
          const centerY = (top + bottom) / 2;
          const r = Math.min(right - left, bottom - top) / 2;

          ctx.beginPath();
          ctx.lineWidth = width || 2;
          ctx.strokeStyle = color || 'rgba(255, 128, 0, 0.5)';
          ctx.arc(centerX, centerY, (r - radiusDecrease || 0), 0, 2 * Math.PI);
          ctx.stroke();
        }
      }
    };
  }
}
